// extracted by mini-css-extract-plugin
module.exports = {"end-shift":"components-ContentHeader-EndShift-EndShift__end-shift--3z0X7","end-shift-disabled":"components-ContentHeader-EndShift-EndShift__end-shift-disabled--3LKf3"};